// Action types + plain action creators only. The login / reset-password /
// change-password thunks that used to live here were never dispatched by any
// component (the Login screens call the services directly) and have been
// removed; LoginReducer still consumes the constants below.
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_LOADING = "LOGIN_LOADING";
export const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR";
export const RESET_PASSWORD_RESPONSE = "RESET_PASSWORD_RESPONSE";
export const CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR";
export const CHANGE_PASSWORD_RESPONSE = "CHANGE_PASSWORD_RESPONSE";


export function loginErrorResponse(error) {
  return {
    type: LOGIN_ERROR,
    ...error,
  };
}

export function resetPasswordErrorResponse(error) {
  return {
    type: RESET_PASSWORD_ERROR,
    ...error,
  };
}


export function changePasswordErrorResponse(error) {
  return {
    type: CHANGE_PASSWORD_ERROR,
    ...error,
  };
}

export function resetPasswordResponse(response) {
  return {
    type: RESET_PASSWORD_RESPONSE,
    response,
  };
}

export function changePasswordResponse(response) {
  return {
    type: CHANGE_PASSWORD_RESPONSE,
    response,
  };
}
